<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="form">
                    <v-container py-0>
                        <v-layout wrap>            
                            <v-flex xs6 md6>
                                <v-text-field :readonly="true" :label="labelJobReqId" v-model.trim="jobReqId"
                                    :rules="rules.jobReqId"/>
                            </v-flex>   

                            <v-flex xs6 md6>
                                <v-text-field :readonly="true" :label="labelJobAppId" v-model.trim="jobAppId"
                                    :rules="rules.jobAppId"/>                    
                            </v-flex>   

                            <v-flex xs6 md6>
                                <v-text-field :readonly="true" :label="labelCandidateId" v-model.trim="candidateId"
                                    :rules="rules.candidateId"/>
                            </v-flex>       

                            <v-flex xs6 md6>
                                <v-select :readonly="value.indicadorAprovado" :label="labelModalidadeContratacao" :items="lista.modalidadeContratacao" return-object v-model="modalidadeContratacao"
                                    item-value="id" item-text="descricao" :no-data-text="cboModalidadeContratacaoSemDados"
                                    :rules="rules.modalidadeContratacao"></v-select>                                
                            </v-flex>                                                           

                            <v-flex xs12 md12>
                                <centro-custo-pick-list :readonly="true" v-model="centroCusto" :pais="pais"
                                    :required="true"></centro-custo-pick-list>
                            </v-flex>                      

                            <v-flex xs12 md12>
                                <cargo-pick-list :readonly="true" v-model="cargo"
                                    :required="true"></cargo-pick-list>
                            </v-flex>  

                            <v-flex xs12 md12>
                                <posicao-pick-list :readonly="true" v-model="posicao" 
                                    :empresa="empresa" :localidade="localidade" :centroCusto="centroCusto"
                                    :required="true"></posicao-pick-list>
                            </v-flex>     

                            <v-flex xs12 md12>
                                <colaborador-pick-list :readonly="true" :label="labelGerenteContratante" 
                                    v-model="gerenteContratante" :required="gerenteContratanteMandatorio" :rules="rules.gerenteContratante"></colaborador-pick-list>
                            </v-flex>     

                            <v-flex xs12 md6>
                                <v-text-field :readonly="value.indicadorAprovado" :label="labelNomePadrinho" v-model.trim="nomePadrinho"
                                    @change="txtNomePadrinho_OnChange"/>
                            </v-flex>   

                            <v-flex xs12 md6>
                                <v-text-field :readonly="value.indicadorAprovado" :label="labelEmailPadrinho" v-model.trim="emailPadrinho"
                                    @change="txtEmailPadrinho_OnChange"/>
                            </v-flex>                                                        
                        </v-layout>
                    </v-container>         
                </v-form>                  
            </v-flex>            
        </v-layout> 
    </v-container>
</template>

<script>
import StringMixin from '@/mixin/string'
import FormMixin from '@/mixin/form'
import StepMixin from './mixin'

import OnboardingConstantes from '@/constants/onboarding/parametrizacao'
import ParametrizacaoUtil from '../../utils/parametrizacao'

import CentroCustoPickList from '@/components/success-factors/centro-custo/PickList'
import CargoPickList from '@/components/success-factors/cargo/PickList'
import PosicaoPickList from '@/components/success-factors/posicao/PickList'
import ColaboradorPickList from '@/components/success-factors/colaborador/PickList'

import ColaboradorApi from '@/api/workspace/success-factors/colaborador'

export default {
    mixins: [ StringMixin, FormMixin, StepMixin ],   
    components: {
        "centro-custo-pick-list": CentroCustoPickList,
        "cargo-pick-list": CargoPickList,
        "posicao-pick-list": PosicaoPickList,
        "colaborador-pick-list": ColaboradorPickList,
    },
    watch:{
        async value(newValue, oldValue){
            if(newValue != null){
                const atributoIdGerente = this.getValorAtributo(OnboardingConstantes.informacoesVaga.ID_GERENTE_CONTRATANTE);
                const atributoNmGerente = this.getValorAtributo(OnboardingConstantes.informacoesVaga.NOME_GERENTE_CONTRATANTE);
                
                let gerente = { id: null, nomeCompleto: null };
                if(atributoIdGerente != null) 
                    gerente.id = newValue.atributo[atributoIdGerente.index].valor;                

                if(atributoNmGerente != null) 
                    gerente.nomeCompleto = newValue.atributo[atributoNmGerente.index].valor;

                const atributoIdGerenteAnterior = ParametrizacaoUtil.getValorAtributo(oldValue, OnboardingConstantes.informacoesVaga.ID_GERENTE_CONTRATANTE);
                if(atributoIdGerenteAnterior != null){
                    var idAnterior = oldValue.atributo[atributoIdGerenteAnterior.index].valor

                    if(gerente.id == idAnterior)
                        return;
                }

                this.gerenteContratante = gerente;
                const successFactors = await ColaboradorApi.listarPorId(gerente.id).catch(erro => this.showSnackbarError(erro.error));   

                if(successFactors.success && successFactors.data != null) 
                    this.gerenteContratante = successFactors.data;

                const loading = this.showLoading();
                let parametrizacaoAtributo = ParametrizacaoUtil.getParametrizacaoAtributo(newValue, OnboardingConstantes.informacoesVaga.MOD_CONTR);

                const listaValores = await ParametrizacaoUtil.listaValores(parametrizacaoAtributo.listaValores.id); 
                this.lista.modalidadeContratacao = listaValores.atributo;

                loading.close(); 
            }
            else{
                this.gerenteContratante = null;
            }
        }
    },  
    data () {
        return { 
            gerenteContratante: null,
            lista:{
                modalidadeContratacao: []
            },          
            rules:{
                jobReqId: [
                    val => {
                        const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.REQUISITION_ID);
                        if(atributo != null){
                            if(this.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                                if((val || null) == null)
                                    return this.jobReqIdObrigatorio;                                
                            }
                        }

                        return true;
                    }
                ],                               
                jobAppId: [
                    val => {
                        const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.APPLICATION_ID);
                        if(atributo != null){
                            if(this.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                                if((val || null) == null)
                                    return this.jobAppIdObrigatorio;                                
                            }
                        }

                        return true;
                    }
                ],  
                candidateId: [
                    val => {
                        const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.CANDIDATE_ID);
                        if(atributo != null){
                            if(this.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                                if((val || null) == null)
                                    return this.jobAppIdObrigatorio;                                
                            }
                        }

                        return true;
                    }
                ],                  
                modalidadeContratacao: [
                    val => {
                        const atributo = this.getValorAtributo(OnboardingConstantes.posicaoFisica.MOD_CONTR);
                        if(atributo != null){
                            if(this.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                                if(atributo.valor == null)
                                    return this.cboNecessitaPosicaoFisicaObrigatorio;                                
                            }
                        }

                        return true;
                    }
                ],                        
                gerenteContratante: [
                    val => {
                        if((val || null) == null)
                            return this.gerenteContratanteObrigatorio;

                        return true;
                    }
                ],      
                nomePadrinho: [
                    val => {
                        const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.NOME_PADRINHO);
                        if(atributo != null){
                            if(this.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                                if((val || null) == null)
                                    return this.nomePadrinhoObrigatorio;                                
                            }
                        }

                        return true;
                    }
                ],              
                emailPadrinho: [
                    val => {
                        const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.EMAIL_PADRINHO);
                        if(atributo != null){
                            if(this.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                                if((val || null) == null)
                                    return this.emailPadrinhoObrigatorio;                                
                            }
                        }

                        return true;
                    },
                    val => this.validateEmail(val) || this.emailPadrinhoInvalido
                ],                                                              
            }                        
        }
    },
    computed: { 
        labelNomePadrinho () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.nome-padrinho');
        }, 
        nomePadrinhoObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.nome-padrinho-obrigatorio');
        },                   
        nomePadrinho:{ 
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.NOME_PADRINHO);

                if(atributo != null){
                    if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != ""))
                        return atributo.valor;
                    else 
                        return null;
                }
                
                return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.NOME_PADRINHO);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].valor = value;
                }
            }
        },      
        labelEmailPadrinho () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.email-padrinho');
        },
        emailPadrinhoObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.email-padrinho-obrigatorio');
        },                         
        emailPadrinhoInvalido(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.email-padrinho-invalido');
        },                     
        emailPadrinho:{ 
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.EMAIL_PADRINHO);

                if(atributo != null){
                    if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != ""))
                        return atributo.valor;
                    else 
                        return null;
                }

                return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.EMAIL_PADRINHO);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].valor = value;
                }
            }
        },   
        labelPosicao () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.posicao');
        }, 
        posicaoObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.posicao-obrigatorio');
        },                        
        posicao:{ 
            get(){                
                const self = this;
                if(self.value != null && self.value != undefined)
                    return this.value.posicao;

                return null;
            },
            set(value){
                const self = this;
                if(self.value != null && self.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                                 
                    if(value != null){
                        onboarding.posicao = value;   
                    }
                    else{
                        onboarding.posicao = null;           
                    }
                    
                    self.$emit("input", onboarding);
                }              
            }
        },                                                                      
        labelCargo () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.cargo');
        },         
        cargo:{ 
            get(){
                const self = this;
                if(self.value != null && self.value != undefined)
                    return this.value.cargo;

                return null;
            },
            set(value){
                const self = this;
                if(self.value != null && self.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                                 
                    if(value != null){
                        onboarding.cargo = value;   
                    }
                    else{
                        onboarding.cargo = null;           
                    }
                    
                    self.$emit("input", onboarding);
                }              
            }
        },                     
        labelGerenteContratante () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.gerente-contratante');
        },       
        gerenteContratanteMandatorio(){
            const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.NOME_GERENTE_CONTRATANTE);
            if(atributo != null){
                if(this.value.atributo[atributo.index].parametrizacao.indicadorMandatorio == true){
                    return true;
                }

                return false;
            }

            return false;
        },
        gerenteContratanteObrigatorio () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.gerente-contratante-obrigatorio');
        },                     
        labelJobReqId () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.job-requisition-id');
        },
        jobReqId:{ 
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.REQUISITION_ID);

                if(atributo != null){
                    if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != ""))
                        return atributo.valor;
                    else 
                        return null;
                }
                else
                    return null;
                
                return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.REQUISITION_ID);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].valor = value;
                    
                    this.$emit("input", onboarding);
                }
            }
        }, 
        jobReqIdObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.job-requisition-id-obrigatorio');
        },                 
        labelJobAppId () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.job-application-id');
        },
        jobAppId:{ 
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.APPLICATION_ID);

                if(atributo != null){
                    if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != ""))
                        return atributo.valor;
                    else 
                        return null;
                }
                else
                    return null;
                
                return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.APPLICATION_ID);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].valor = value;
                    
                    this.$emit("input", onboarding);
                }
            }
        }, 
        jobAppIdObrigatorio(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.job-application-id-obrigatorio');
        },      
        candidateId:{ 
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.CANDIDATE_ID);

                if(atributo != null){
                    if((atributo.listaValores == true && atributo.valor != null) || (atributo.listaValores == false && this.$_.trim(atributo.valor) != ""))
                        return atributo.valor;
                    else 
                        return null;
                }
                else
                    return null;
                
                return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.CANDIDATE_ID);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].valor = value;
                    
                    this.$emit("input", onboarding);
                }
            }
        },                     
        labelCandidateId () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.candidate-id');
        },  
        labelModalidadeContratacao () {
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.modalidade-contratacao');
        },            
        cboModalidadeContratacaoSemDados(){
            return this.$t('Views.Onboarding.Colaborador.PreCadastro.nenhuma-opcao-modalidade-contratacao')            
        },             
        modalidadeContratacao:{
            get(){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.MOD_CONTR);
                if(atributo == null || atributo.valor == null) return null;

                if((atributo.valor || { id: null}).id != null)
                    return atributo.valor;

                return null;
            },
            set(value){
                const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.MOD_CONTR);
                if(atributo != null){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.atributo[atributo.index].listaValoresAtributo = value;
                    
                    this.$emit("input", onboarding);
                }
            }
        }, 
        listaModalidadeContratacao(){
            const atributo = this.getValorAtributo(OnboardingConstantes.informacoesVaga.MOD_CONTR);
            if(atributo != null && this.value.atributo[atributo.index].listaValoresAtributo != null)
                return [ this.value.atributo[atributo.index].listaValoresAtributo ];

            return [];   
        },             
        centroCusto:{ 
            get(){
                const self = this;
                if(self.value != null && self.value != undefined)
                    return this.value.centroCusto;

                return null;
            },
            set(value){
                const self = this;
                if(self.value != null && self.value != undefined){
                    let onboarding = this.$_.clone(this.value);
                    onboarding.centroCusto = value;   
                    
                    self.$emit("input", onboarding);
                }              
            }
        },     
        pais(){
            if(this.value == undefined || this.value == null)
                return null;

            return this.value.pais;
        },        
        empresa(){
            if(this.value == undefined || this.value == null)
                return null;

            return this.value.empresa;
        },
        localidade(){
            if(this.value == undefined || this.value == null)
                return null;

            return this.value.localidade;
        }           
    },
    async created(){
        this.$events.$on("locale-has-changed", this.setLocale);
    },
    beforeDestroy(){
        this.$events.$off("locale-has-changed", this.setLocale);
    },      
    methods:{
        async setLocale(){
            const loading = this.showLoading();
            let parametrizacaoAtributo = ParametrizacaoUtil.getParametrizacaoAtributo(this.value, OnboardingConstantes.informacoesVaga.MOD_CONTR);

            const listaValores = await ParametrizacaoUtil.listaValores(parametrizacaoAtributo.listaValores.id); 
            this.lista.modalidadeContratacao = listaValores.atributo;

            loading.close(); 
        },        
        txtNomePadrinho_OnChange(){
            let onboarding = this.$_.clone(this.value);
            this.$emit("input", onboarding);
        },
        txtEmailPadrinho_OnChange(){
            let onboarding = this.$_.clone(this.value);
            this.$emit("input", onboarding);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";

</style>
